import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { postRequest as post } from '../utils/HttpMethods';
import { useNotification } from '@refinedev/core';

interface GenerateClaimCSVResponse {
  url: string;
}

const generateClaimCSV = async ({
  siteID,
  filters,
  globalFilter = '',
  sorting = '',
  providerIDs = [],
}: {
  siteID: string;
  filters: string;
  globalFilter?: string;
  sorting?: string;
  providerIDs?: string[];
}): Promise<GenerateClaimCSVResponse> => {
  try {
    const response: string = await post(
      'QBilling',
      '/action/generate/csv/claim',
      {
        siteID,
        filters,
        globalFilter,
        sorting,
        providerIDs,
      }
    );
    return { url: response };
  } catch (error) {
    throw new Error('Failed to generate CSV');
  }
};

export const useGenerateClaimCSV =
  (): UseMutationResult<GenerateClaimCSVResponse> => {
    const { open } = useNotification();
    return useMutation({
      mutationFn: generateClaimCSV,
      onError: (error) => {
        open({
          message: 'Error generating CSV',
          description: error.message,
          type: 'error',
        });
      },
      onSuccess: () => {
        open({
          message: 'CSV Generated',
          description: 'CSV file has been generated successfully.',
          type: 'success',
        });
      },
    });
  };
